module.exports = __webpack_public_path__ + "static/media/flowingwater_audio.8b22ada2.mp4";